import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import axios from 'axios'
import Table from '../_Components/AdminTable.js'
import { useTable } from 'react-table'
import Variables from '../../global.js'
import { call } from '../../Methods.js'

function _Discounts () {
  const pageTitle = 'Discounts'
  const [loading, setLoading] = useState(true)

  const defaultParameters = {
    parentId: '',
    type: '',
    enabled: '',
    statusId: ''
  }

  let tableColumns = [
    {
      title: 'Code',
      property: 'code'
    },
    {
      title: 'Percent',
      property: 'discountPercent'
    },
    {
      title: 'Create Date',
      property: 'createDate',
      mutate: value => {
        return value?.substring(0,10)
      }
    },
    {
      title: 'Active Till',
      property: 'activeTillDate',
      mutate: value => {
        return value?.substring(0,10)
      }
    },
    {
      title: 'Active',
      property: 'statusId',
      type: 'label',
      mutate: value => {
        return value == 0 ? (
          <span className='label-red'>deactive</span>
        ) : (
          <span className='label-green'>active</span>
        )
      }
    },
    {
      title: 'Actions',
      property: 'id',
      type: 'actions-list',
      mutate: value => {
        return (
          <>
            <Link to={`/admin/discount/${value}`}>
              <img
                className='action-icon'
                title={'Edit'}
                src={'/Icons/edit.png'}
              />
            </Link>
          </>
        )
      }
    }
  ]

  const getData = async () => {
    setLoading(true)
    const _discounts = await call.forLoggedUser.discount.getDiscounts({});
    if(_discounts.success){
      setLoading(false)
      return _discounts
    }
    return false;    
  }

  return (
    <React.Fragment>
      <h3 className='page-title'>{pageTitle}</h3>
      {<Table
            columns={tableColumns}
            getMethod={getData}
            loading={loading}
            pagination={{ enable: false }}
            addNew={{ enabled: true, url: '/admin/discount/add' }}
        />
      }

    </React.Fragment>
  )
}

export default _Discounts
